<template>
    <div>
       <commBanner :obj="obj"></commBanner>
       <titleHead :headTitle="headTitle"></titleHead>
       <div class="w80 mb-30">
           <el-container>
            <el-aside width="330px">
                <sidebar></sidebar>
            </el-aside>
            <el-main>
                <companySide v-if="type" :isButton="isButton" @release="gorelease()"></companySide>
                <headSide v-else @release="gorelease()"></headSide>
                <div style="margin-top:40px;">
                    <div class="meas_list">    
                        <p>
                           <span class="line"></span>
                           <span class="needs_text">我的消息</span>
                        </p> 
                        <p class="meas_read">
                           <span class="unread" style="margin-left:72%" @click="Notread()">未读</span>
                           <span class="unread" @click="onRead()">已读</span>
                        </p>
                        
                    </div>
                    <div class="message_conent">
                        <div :class="[active != item.id?'message_middle':'message_middles']" v-for="(item,index) in list" :key="index"  @click="onView(item)"> 
                           <p class="message_title">{{item.title}}</p>
                           <p class="message_conts" v-html="item.content"></p>
                           <p class="message_cox">
                               <span class="message_cont">{{item.senddate}}</span>
                               <span :class="[item.readFlag == 0?'message_text':'message_cont']">{{item.readFlag ==0?'未读':'已读'}}</span>
                           </p>
                        </div>
                    </div>
                    <div class="messahe_dialog">
                        <el-dialog title="消息详情" :visible.sync="dialogVisible">
                          <div class="dialog_box"> 
                                <p class="dialog_title ml-30 mb-15">{{messageObj.title}}</p>
                                <div class="dialog_center" v-html="messageObj.content"></div>
                                <div class="dialog_foot">
                                    <p>系统消息</p>
                                    <p class="mr-40">{{messageObj.senddate}}</p>
                                </div>
                          </div>
                          
                        </el-dialog>

                    </div>
                    <!--分页-->
                    <Pagination
                    v-show="total > 0"
                    :total="total"
                    :page.sync="listQuery.curPage"
                    :limit.sync="listQuery.limit"
                    @pageChange="pageChange"
                    ></Pagination>


                    <div style="margin-top:20%;">
                       <notList :notCode="notCode"></notList>
                    </div>
                </div>
            </el-main>
          </el-container>
       </div>
    </div>
</template>
<script>
import {mesList,mesInfo,mesStatus} from "@/api/coment"
import sidebar from '../../common/sidebar'
import headSide from '../../common/headSide'
import companySide from '../../common/companySide'
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
import Pagination from '../../components/Pagination'
import notList from '../../common/notList'
export default {
   components:{
      sidebar,headSide,commBanner,titleHead,Pagination,notList,companySide
   },
   data(){
       return{
           headTitle:'消息中心',
           obj:{
             title:'消息中心',
             roleType:'',
             personalType:9
            //  content:'公司主营产品及服务包括:金属氧化物避雷器带电检测仪、数字式钳形伏安相位表、大型地网接地电阻测量仪、多通道波形记录仪、PT感应耐压试验电源、高压高稳定电源...',
            //  bannerUrl:require('@/assets/images/banner.jpg')
           },
           dialogVisible:false,
           active:0,
           list:[],
           ids:[],
           listQuery:{
             curPage:1,
             limit:6,
            },
          total:0,//总条数
          text:'',
          messageObj:{},
          unreadList:[], //未读
          readList:[], //已读
          notList:[],
          unreadCount:'',
          readCount:'',
          type:false,
          notCode:false,
          isButton:false
       }
   },
   created(){
       this.getList();
       let type = this.$store.state.user.userInfo.type;
       this.obj.roleType = type;
       if(type == 3){
          this.type = true;
       }
   },
   methods:{
       onView(data){        
          this.messageObj = data;
          this.dialogVisible = true;
          this.active = data.id;
          let params = {msgid:data.id}
          if(data.readFlag == 1){
             return false;
          }else{
            mesStatus(params).then(res=>{
            if(res.code == 0){
              this.list.forEach(element => {
              if(data.id== element.id) {
                  element.readFlag=1;                 
                }      
            });        
            }
            }).catch(err=>{})
          }
       },
       //列表
       getList(){
          mesList(this.listQuery).then((res)=>{
             if(res.code ==0){
                this.list = res.page.records;
                this.total = res.page.total;
                this.list.length == 0 ? this.notCode = true : this.notCode = false; 
			       }
          }).catch((err)=>{})
       },
      //分页
       pageChange(item){
         this.listQuery['curPage'] = item.page;
         this.listQuery['limit'] = item.limit;
         this.getList();
      },
      //发布需求
      gorelease(){
        this.$router.push('/demand')
      },
      //未读
      Notread(){
         this.listQuery.readFlag = 0;
         mesList(this.listQuery).then((res)=>{
           if(res.code == 0){                       
             this.list=[];
             this.total = 0;
             try {
                this.unreadList = res.page.records;
                this.total = res.page.total;
                this.list = this.unreadList;    
             } catch (error) {} 
             this.total == 0 ? this.notCode = true : this.notCode = false;    
           }
         }).catch((err)=>{})
      },
      //已读
      onRead(){
        this.listQuery.readFlag = 1;
         mesList(this.listQuery).then((res)=>{
           if(res.code == 0){
             this.total= 0;
             try { 
                 this.readList = res.page.records;
                this.total = res.page.total;
                this.list = this.readList;               
             } catch (error) {} 
              this.total == 0 ? this.notCode = true : this.notCode = false;      
           }
         }).catch((err)=>{})
      },
      //获取余额信息
      getMyfunds(){
      myfunds().then((res)=>{
        if(res.code ==0){
          this.balaInfo = res.data;
        }
      }).catch((err)=>{});
     }
   } 
}
</script>
<style scoped>

.mt-25{
    margin-top: 25px;
}
.ml-30{
    margin-left: 30px;
}
.mr-40{
    margin-right: 40px;
}
.mb-15{
   margin-bottom: 15px;
}
.line{
  width: 5px;
  height: 23px;
  background: #FF7302;
  display: inline-block;
}
.needs_text{
  margin-left: 12px; 
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.unread{    
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-left: 15px;
}
.unread:hover{
  cursor: pointer;
  color: #FF7402;
}
.message_conent{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    flex-wrap: wrap;
}
.meas_list{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.meas_list p:nth-child(1){
    width: 40%;
    text-align: left;
}
.meas_read{
   width: 60%;
   justify-content: space-betweens;
   align-items: center;
}
.message_middle{
    width:48.4%; 
    border: 1px solid #DCDCDC;
    padding:12px 12px;
    text-align: left;
    margin-bottom: 25px;
	  transition: all 0.5s;
    height: 157px;
    /* overflow: hidden; */
}
.message_middle:hover{
  box-shadow: 0 0 20px #ddd;
}
.message_middles{
    width:48.4%; 
    border: 1px solid #DCDCDC;
    padding:12px 12px;
    text-align: left;
    background: #81D3F8;
    margin-bottom: 25px;
  	transition: all 0.5s;
}
.message_middles:hover{
  box-shadow: 0 0 20px #ddd;
}
.message_title{ 
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  /* height: 50px; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.message_cox{
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.message_cont{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  text-align: left;
  line-height: 24px;
}
.message_conts{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  text-align: left;
  line-height: 24px;
  height: 50px;
  overflow: hidden;
  margin-top: 10px;
}
.message_conts>>>p{
  /* height: 50px; */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.message_text{
 font-size: 14px;
 font-family: Microsoft YaHei;
 font-weight: 400;
 color: #FF4F4F;
 text-align: left;
 line-height: 24px; 
}

.el-pagination{
   margin: 30px 0px;
}

.el-pagination{
   margin: 30px 0px;
}
.dialog_box{
    text-align: left;
}
.dialog_title{
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.dialog_center{
    width: 90%;
    height: 200px;
    margin: 0 auto;
    background: #F8F8F8;
    font-size: 16px;
    padding: 15px 15px;
}
.messahe_dialog>>>.el-dialog__header{
    padding: 33px 20px 10px;
}
.messahe_dialog>>>.el-dialog__title{
    font-size: 24px;
    font-weight: bold;
    margin-top: 20px;
}
.dialog_foot{
   margin: 30px 40px;
   display: flex;
   justify-content: space-between;
   align-items: center;
}
.dialog_foot p{
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
</style>


// WEBPACK FOOTER //
// src/view/coment/message.vue